import React, { useEffect, useRef, useState } from "react";
import "./product.css";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

function Products({selectedTool, setSelectedTool}) {
  const [activeSection, setActiveSection] = useState("");
  const sectionRefs = useRef({});

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveSection(entry.target.id);
          }
        });
      },
      { threshold: 0.6 }
    );

    Object.values(sectionRefs.current).forEach((ref) => {
      if (ref) observer.observe(ref);
    });

    return () => observer.disconnect();
  }, []);

  useEffect(()=>{
    setSelectedTool("/products")
  })
  return (
    <div className="pr-layout-container" style={{ backgroundColor: "#B24C76" }}>
      <Helmet>
        <title>
          Products for Moms & Babies - Comfort, Care, and Convenience
        </title>
        <meta
          name="description"
          content="Find everything a mom-to-be needs, all your essentials in one place, plus the best products for your newborn baby."
        />
        <meta
          name="keywords"
          content="Baby products list, pregnancy products for moms, pregnancy must have
"
        />
      </Helmet>
      {/* Right Column ..................*/}
      <div className="right-column">
        <div className="bread-container">
          <nav aria-label="breadcrumb">
            <ol className="crumb">
              <li className="breadcrumblist">
                <Link to="/" className="breadcrumb-link" onClick={()=>setSelectedTool("")}>
                  Home
                </Link>
              </li>
              <li className="breadcrumblist">
                <Link to="/tools" className="breadcrumb-link">
                  Tools
                </Link>
              </li>
              <li className="breadcrumblist active">Products</li>
            </ol>
          </nav>
        </div>
        <h2 style={{ textAlign: "center" }} className="head-pr">
          {" "}
          Pregnancy Products
        </h2>
        <div id="mothers" ref={(el) => (sectionRefs.current["mothers"] = el)}>
          <h3 className="pr">For Moms</h3>
          <p className="right-p" style={{ color: "grey" }}>
            Everything a mom-to-be needs, all in one place! From comfy maternity
            wear to essential accessories, we’ve got you covered for every step
            of your pregnancy journey. Find all the must-haves to make your
            experience easier, stylish, and more comfortable along the way!
          </p>
          <Link to="momproducts">
            {" "}
            <button className="visit">Purchase</button>
          </Link>
        </div>

        <div id="babies" ref={(el) => (sectionRefs.current["babies"] = el)}>
          <h3 className="pr">For Babies</h3>
          <p className="right-p" style={{ color: "grey" }}>
            Shop all your baby essentials in one place! From soft, cosy blankets
            to fun and playful toys, we have everything your little one needs to
            stay happy and comfortable. Make parenting easier with our carefully
            curated collection of must-have items for your baby!
          </p>
          <Link to="babyproducts">
            <button className="visit">Purchase</button>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Products;
